import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

type UseCrawlJobStatusQueryOptions = {
  crawlId: string | undefined;
  enabled?: boolean;
};

export function useCrawlJobStatusQuery({
  crawlId,
  enabled = true,
}: UseCrawlJobStatusQueryOptions) {
  const { user } = useAuth();
  const trimmedId = crawlId?.trim() ?? '';
  const isEnabled = enabled && Boolean(user) && trimmedId !== '';

  return useQuery({
    queryKey: knowledgeQueryKeys.crawlJobStatus(trimmedId),
    enabled: isEnabled,
    queryFn: () => knowledgeService.getCrawlJobStatus(trimmedId),
  });
}
